/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSupplierDto
 */
export interface CreateSupplierDto {
    /**
     * Supplier first name
     * @type {string}
     * @memberof CreateSupplierDto
     */
    firstName: string;
    /**
     * Supplier last name
     * @type {string}
     * @memberof CreateSupplierDto
     */
    lastName: string;
    /**
     * Supplier email address
     * @type {string}
     * @memberof CreateSupplierDto
     */
    email: string;
    /**
     * Supplier phone number in international format
     * @type {string}
     * @memberof CreateSupplierDto
     */
    phoneNumber: string;
    /**
     * Supplier password (will be hashed)
     * @type {string}
     * @memberof CreateSupplierDto
     */
    password: string;
    /**
     * Supplier roles array
     * @type {Array<string>}
     * @memberof CreateSupplierDto
     */
    roles: Array<CreateSupplierDtoRolesEnum>;
    /**
     * Is supplier confirmed by admin
     * @type {boolean}
     * @memberof CreateSupplierDto
     */
    isConfirmed: boolean;
    /**
     * Organization ID that supplier belongs to
     * @type {number}
     * @memberof CreateSupplierDto
     */
    organizationId?: number;
}


/**
 * @export
 */
export const CreateSupplierDtoRolesEnum = {
    GlobalSupplierAdmin: 'GLOBAL_SUPPLIER_ADMIN',
    PromotionSupplierAdmin: 'PROMOTION_SUPPLIER_ADMIN',
    CatalogSupplierAdmin: 'CATALOG_SUPPLIER_ADMIN',
    OrderSupplierAdmin: 'ORDER_SUPPLIER_ADMIN',
    AddProductSupplierAdmin: 'ADD_PRODUCT_SUPPLIER_ADMIN',
    ReadOnlySupplierAdmin: 'READ_ONLY_SUPPLIER_ADMIN'
} as const;
export type CreateSupplierDtoRolesEnum = typeof CreateSupplierDtoRolesEnum[keyof typeof CreateSupplierDtoRolesEnum];


/**
 * Check if a given object implements the CreateSupplierDto interface.
 */
export function instanceOfCreateSupplierDto(value: object): value is CreateSupplierDto {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('isConfirmed' in value) || value['isConfirmed'] === undefined) return false;
    return true;
}

export function CreateSupplierDtoFromJSON(json: any): CreateSupplierDto {
    return CreateSupplierDtoFromJSONTyped(json, false);
}

export function CreateSupplierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSupplierDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'],
        'password': json['password'],
        'roles': json['roles'],
        'isConfirmed': json['isConfirmed'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
    };
}

export function CreateSupplierDtoToJSON(value?: CreateSupplierDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'password': value['password'],
        'roles': value['roles'],
        'isConfirmed': value['isConfirmed'],
        'organizationId': value['organizationId'],
    };
}

